import React from 'react';
interface SectionTagProps {
  children: React.ReactNode;
  className?: string;
}

/** Eyebrow dorado sobre fondo oscuro. */
export function SectionTag({
  children,
  className = ''
}: SectionTagProps) {
  return <span className={`inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold/10 px-3.5 py-1.5 font-display text-[0.62rem] uppercase tracking-editorial text-gold ${className}`} data-id="element-156" data-mp="20pv84jm0vaoy">
      <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden data-id="element-157" data-mp="2ao164q4pjwoj" />
      {children}
    </span>;
}